import React from 'react';
import bootstrap from 'bootstrap/dist/css/bootstrap.css';
import { Button, Modal, ModalBody } from 'reactstrap';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import s from '../../assets/styles/style.sass';
import s2 from './dialog.sass';
import { setIsShowBonusPriceDialog } from '../../actions/dialog';

class bonusPriceDialog extends React.Component {
  static propTypes = {
    currentLocale: PropTypes.string.isRequired,
    setIsShowBonusPriceDialog: PropTypes.func.isRequired,
    modal: PropTypes.bool.isRequired,
  };
  constructor(props) {
    super(props);
    let langType = props.currentLocale.split('-')[0]; // en-SG
    const lang = props.currentLocale.split('-')[1].toLowerCase();
    if (lang === 'hk') {
      langType = `${langType}-${lang}`;
    } else {
      langType = lang;
    }
    this.state = {
      modelDataText: require(`../../assets/src/scripts/gogovan/order/${lang}/${langType}.json`),
    };
  }
  render() {
    return (
      <div id="blacklist">
        <Modal
          size="lg"
          className={`${s2.dialog} ${s2.infoPopup}`}
          // isOpen={this.props.modal}
          isOpen={this.props.modal}
          toggle={() => {
            this.props.setIsShowBonusPriceDialog();
          }}
        >
          <Button
            outline
            color="link"
            className={`${s.infoCloseRightButton} ${s2.dialogOverlayClose} ${
              s2.orderCancelcloseRightButton
            }`}
            onClick={() => {
              this.props.setIsShowBonusPriceDialog();
            }}
          />
          <ModalBody
            className={`${s2.infoContainer} ${s2.orderCancelContainer}`}
            style={{ padding: 0 }}
          >
            <div className={s2.infoHeadline}>
              <h2 className={s.globalFontLight}>
                {this.state.modelDataText.order.order_dialog_info_bonus_title}
              </h2>
            </div>
            <div className={s2.infoContent}>
              <p>
                {this.state.modelDataText.order.order_dialog_info_bonus_body}
                <br />
                {this.state.modelDataText.order.order_dialog_info_bonus_body_2}
              </p>
            </div>
          </ModalBody>
        </Modal>
      </div>
    );
  }
}
const mapState = state => ({
  currentLocale: state.intl.locale,
  modal: state.dialog.isShowBonusPriceDialog,
});
const mapDispatch = {
  setIsShowBonusPriceDialog,
};
export default connect(mapState, mapDispatch)(
  withStyles(bootstrap, s, s2)(bonusPriceDialog),
);



// WEBPACK FOOTER //
// ./src/components/Dialog/bonusPriceDialog.js